import { SEND_SMS_FAILURE, SEND_SMS_REQUEST, SEND_SMS_SUCCESS } from 'actions/sms/bePutClientSmsText.types';
import CONF from 'config/conf.singleton';
import { AUTH_API } from 'middleware/api';
import withOptions from 'utils/functions/withOptions.util';

// TODO: Replace with new action that has actionBe and targeted setting change
// SEE: src/actions/sms/bePutClientSmsText.action.js
// SEE: src/actions/sms/bePutSalonFlagSettings.action.js
const bePutSendSms = withOptions(({ salonId, ...data }) => ({
  [AUTH_API]: {
    api_root: CONF.apiRoot,
    endpoint: `salon/${salonId}/`,
    authenticated: true,
    types: [SEND_SMS_REQUEST, SEND_SMS_SUCCESS, SEND_SMS_FAILURE],
    params: { method: 'PUT', salonId },
    config: {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    },
  },
}));

export default bePutSendSms;
